import React from "react";
import useGoToPricing from "../../hooks/useGoToPricing";
import Header from "../Homepage/sections/Header";
import { Page, HomepageGlobalStyles } from "../Homepage/styles";
import RegisterCheckout from "./RegisterCheckout";
import {
  RegisterFooterLink,
  RegisterFooterNote,
  RegisterGlow,
  RegisterHomeLink,
  RegisterHomeWrap,
  RegisterInner,
  RegisterMain,
  RegisterPage as RegisterPageRoot,
  RegisterShell,
} from "./Register.styles";

const ArrowLeftIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m12 19-7-7 7-7" />
    <path d="M19 12H5" />
  </svg>
);

/**
 * Lovable Register shell + Homepage Header + RegisterCheckout (prod behavior).
 */
const Register = () => {
  const goToPricing = useGoToPricing();

  return (
    <Page>
      <HomepageGlobalStyles />
      <RegisterPageRoot>
        <RegisterGlow aria-hidden="true" />
        <RegisterShell>
          <Header onSubscribeClick={goToPricing} hideSpacer />

          <RegisterMain>
            <RegisterInner>
              <RegisterCheckout />

              <RegisterFooterNote>
                Already have an account?{" "}
                <RegisterFooterLink to="/login">Log in</RegisterFooterLink>
              </RegisterFooterNote>

              <RegisterHomeWrap>
                <RegisterHomeLink to="/">
                  <ArrowLeftIcon />
                  Back to home
                </RegisterHomeLink>
              </RegisterHomeWrap>
            </RegisterInner>
          </RegisterMain>
        </RegisterShell>
      </RegisterPageRoot>
    </Page>
  );
};

export default Register;
